export default __webpack_public_path__ + "/dist/images/ai-card-bottom.684e8a47f8ebe77c5064e7dde30cc9c5.png";